import styled from 'styled-components'
import { Button } from '@components/Button'
import { black, grey, orange, textMuted } from '@/theme/colors'
import { motion, radii, shadows } from '@/theme/tokens'
import { text } from '@/theme/typography'

/** The stream and the floating button over its bottom corner. */
export const StreamFrame = styled.div`
	position: relative;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	background: ${grey};
`

/** Scrolls on its own; positioned, so rows measure their offsets from it. */
export const StreamScroller = styled.div`
	position: relative;
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	overscroll-behavior: contain;
	padding: 8px 0 12px;
`

export const DaySeparator = styled.div`
	${text.caption}
	color: ${textMuted};
	text-align: center;
	padding: 16px 16px 8px;
`

/** "2 new · Today" between two orange rules, at the first Message I haven't read. */
export const UnreadDivider = styled.div`
	${text.caption}
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 14px 16px 8px;
	color: ${orange};

	&::before,
	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background: ${orange}80;
	}
`

export const StreamNotice = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 100%;
	padding: 32px 16px;
	text-align: center;
`

export const StreamNoticeTitle = styled.p`
	${text.title}
	margin: 0;
	color: ${black};
`

export const StreamNoticeMessage = styled.p`
	${text.bodySm}
	margin: 0;
	color: ${textMuted};
`

/** Floats over the stream's bottom corner while it's scrolled up; back to the newest Message. */
export const ScrollToBottomButton = styled(Button).attrs({ variant: 'secondary' })<{ $shown: boolean }>`
	position: absolute;
	right: 16px;
	bottom: 12px;
	width: 40px;
	height: 40px;
	padding: 0;
	border-radius: ${radii.round};
	color: ${orange};
	box-shadow: ${shadows.card};
	opacity: ${({ $shown }) => ($shown ? 1 : 0)};
	pointer-events: ${({ $shown }) => ($shown ? 'auto' : 'none')};
	transition:
		opacity ${motion.base},
		background-color ${motion.fast};
`
